<template>
    <div class="carousel_wrap_mobile">
        <el-carousel height="150px" loop arrow="never">
            <el-carousel-item v-for="(item, index) in imgList" :key="index"
            :style="{background: `url(${item.src}) no-repeat`, backgroundSize: 'cover', backgroundPosition: 'center'}">
                <!-- <img :src="item.src" alt="" class="img_item" /> -->
                <div class="ho_to"></div>
                <div class="ti_font">
                    <div class="logo-line1-row">
                        <!-- <img src="@/assets/home/chnsoft.png" alt="chnsoft" class="chnsoftImg" /> -->
                        <h1 class="line1-text"><span class="highlight-text">华软股份 <span
                            style="opacity: 0.1;">| </span> </span><span>{{ item.line1}}</span>
                        </h1>
                    </div>
                    <div class="logo-line1-row" style="white-space: nowrap;">
                        <div class="line1-text" style="padding-left: 84px;"><span class="line2-text">{{
                            item.line2 }}</span></div>
                    </div>
                    <!-- <h1 class="line2-text">{{ item.line2 }}</h1> -->
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imgList: [
                {
                    src: require(`@/assets/home/aboutTop.png`),
                    line1: '引领智能化变革', // 动态设置 line1
                    line2: '具身智能及无人异构集群技术在工业场景应用的先行者',

                }
            ],
            currentSource: '', // 用于存储当前的 source 参数
        };
    },
    created() {
        // this.updateImgList();
        this.currentSource = new URLSearchParams(window.location.search).get('source') || '';
    },
    // watch: {
    //   // 监听 URL 的变化
    //   '$route.fullPath': {
    //     immediate: true,
    //     handler() {
    //       const urlParams = new URLSearchParams(window.location.search);
    //       const source = urlParams.get('source');
    //       if (source !== this.currentSource) {
    //         this.currentSource = source;
    //         this.updateImgList();
    //       }
    //     },
    //   },
    // },
    methods: {
        //   updateImgList() {
        //     const urlParams = new URLSearchParams(window.location.search);
        //     const source = urlParams.get('source');
        //     const selectedText = localStorage.getItem('selectedText') || '默认文本'; // 获取 localStorage 中的 selectedText
        //     if (source) {

        //       this.imgList = [
        //         {
        //           src: require(`@/assets/home/aboutTop.png`),
        //           line1: selectedText, // 动态设置 line1
        //           line2: '是面向立体空间的全维度无人化智能巡视解决方案，核心实现空、地、海无人装备作业的一体化管控，突破多场景壁垒，织就贯通空、地、海立体巡视网，依托于异构协同、人工智能、边缘计算等新兴技术，实现从装备调度到数据研判的全链条自动化，为各领域筑牢高效精准的全域态势感知屏障。',
        //         },
        //         // 可以根据需要添加更多图片
        //       ];
        //     } else {
        //       this.imgList = []; // 清空 imgList 以防止显示旧数据
        //     }
        //   },
    },
};
</script>

<style lang="scss" scoped>
.ho_to {
    // position: absolute;
    width: 100%;
    // height: 100%;
    // margin-top: 40PX;
    // background: linear-gradient(180deg, rgba(28, 54, 93, 0.9) 0%, rgba(28, 54, 93, 0.3) 100%, rgba(28, 54, 93, 0) 100%);
}

.carousel_wrap_mobile {
    position: relative;
    // margin-top: 40PX;

    .el-carousel__item {
        img {
            width: 100%;
            // height: 100%;
            object-fit: cover;
        }
    }

    .ti_font {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
        font-family: PingFang SC;
        letter-spacing: normal;
        color: #1E242A;
        padding: 0 35PX;
        height: 145px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        /* Removed the previous font-size declaration */
        .chnsoftImg {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
            vertical-align: middle;
            margin: 0PX;
        }

        .logo-line1-row {
            display: flex;
            align-items: center;

            /* 保证图片和文字垂直居中 */
            h1.line1-text {
                margin-left: 6PX;
                font-weight: bold;
                line-height: 1;

                font-family: PingFang SC;
                font-size: 16PX;
                font-weight: bold;
                line-height: 30PX;
                letter-spacing: normal;
                /* 1E242A */
                color: #1E242A;

            }
        }

        .line2-text {
            font-family: PingFang TC;
            font-size: 10PX;
            line-height: normal;
            color: #1E242A;
            margin-top: 8PX;
            white-space: nowrap;
            font-weight: normal !important;
        }





    }
}

::v-deep .el-carousel__button {
  display: none;
}
</style>